module.exports = __webpack_public_path__ + "static/media/claire-distribution-services.d831c2b2.jpg";